import { render, staticRenderFns } from "./FloatingCustomerService.vue?vue&type=template&id=1ec7394b&scoped=true"
import script from "./FloatingCustomerService.vue?vue&type=script&lang=js"
export * from "./FloatingCustomerService.vue?vue&type=script&lang=js"
import style0 from "./FloatingCustomerService.vue?vue&type=style&index=0&id=1ec7394b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec7394b",
  null
  
)

export default component.exports